import React, { CSSProperties } from 'react';
import { Scrollbars as ReactCustomScrollbars } from 'react-custom-scrollbars';

export type ScrollbarPublicProps = {
  scrollTrackClass?: string;
  scrollThumbClass?: string;
  scrollContentsClass?: string;
  scrollMainClass?: string;
  hideX?: boolean;
};

type ScrollbarsProps = {
  children: React.ReactNode;
} & ScrollbarPublicProps & { [key: string]: any };

const Scrollbars = ({
  children,
  forwardedRef,
  scrollTrackClass = 'scroll-track-vertical',
  scrollThumbClass = 'scroll-thumb-vertical',
  scrollContentsClass = 'scroll-contents',
  scrollMainClass = 'scroll-main',
  hideX = false,
  ...others
}: ScrollbarsProps & { forwardedRef: React.ForwardedRef<ReactCustomScrollbars> }) => {
  const additionalStyles: Partial<CSSProperties> = hideX ? { overflowX: 'hidden' } : {};

  return (
    <ReactCustomScrollbars
      renderTrackVertical={(props) => <div {...props} className={scrollTrackClass} />}
      renderThumbVertical={(props) => <div {...props} className={scrollThumbClass} />}
      renderView={(props: { style: CSSProperties }) => (
        <div {...props} className={scrollContentsClass} style={{ ...props.style, ...additionalStyles }} />
      )}
      className={scrollMainClass}
      ref={forwardedRef}
      {...others}
    >
      {children}
    </ReactCustomScrollbars>
  );
};

const FwdScrollbars = React.forwardRef<ReactCustomScrollbars, ScrollbarsProps>((props, ref) => (
  <Scrollbars {...props} forwardedRef={ref} children={props.children} />
));

export default FwdScrollbars;
